import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { FolderOpen } from 'lucide-react';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';

interface EmptyStateProps {
    title: string;
    message: string;
    icon?: React.ReactNode;
    action?: React.ReactNode;
}

export function EmptyState({ title, message, icon, action }: EmptyStateProps) {
    const { themeStyle } = useThemeContext();
    const cardBg = theme[themeStyle].secondaryBg;
    const textColor = theme[themeStyle].tag_white;

    return (
        <Paper
            elevation={0}
            sx={{
                backgroundColor: themeStyle === 'dark' ? '#1a1919' : cardBg,
                border: `1px solid rgba(255,255,255,0.06)`,
                borderRadius: 2,
                p: { xs: 4, sm: 6 },
                textAlign: 'center',
                minHeight: { xs: 220, sm: 260 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
            <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                {icon || <FolderOpen size={48} style={{ color: textColor, opacity: 0.6 }} />}
                <Typography variant="h6" fontWeight={600} sx={{ color: textColor }}>
                    {title}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: themeStyle === 'dark' ? '#adaaaa' : textColor,
                        opacity: themeStyle === 'dark' ? 1 : 0.8,
                        maxWidth: 400,
                    }}>
                    {message}
                </Typography>
                {action}
            </Box>
        </Paper>
    );
}
